import { connect } from "react-redux";
import QueuesComponent from "../../Components/RealtimeDashboard/QueuesComponent";

const mapStateToProps = (state) => ({
  // Les agents viennent déjà du parent (RealtimeDashboard)
  // Pas besoin de les récupérer ici
});

const mapDispatchToProps = (dispatch) => ({
  // Add dispatch actions here if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(QueuesComponent);
